import { IoCheckmarkCircleOutline } from "react-icons/io5"
import { BiCoinStack } from "react-icons/bi"
import { IoLockClosedOutline } from "react-icons/io5"
import { BiLike } from "react-icons/bi"
import { MdOutlineInsights } from 'react-icons/md'; // Tailored Predictive Analytics
import { MdOutlineLightbulb } from 'react-icons/md';
import img1 from "../../../assets/img/EngineeringExcellence/ProductEngineering/1.jpeg";
import { FaChartLine } from 'react-icons/fa';
import { AiOutlineUser } from 'react-icons/ai';
import { MdOutlineHealthAndSafety } from 'react-icons/md';
import {FaSearch, FaUserAlt, FaCheckCircle} from "react-icons/fa"

export default function MainSection1() {
  return (
    
    <div className="container mx-auto px-4 py-12 md:py-12 md:px-10">
       <div className="flex flex-col mb-6 justify-center lg:justify-center lg:flex-row md:mb-8">
          <h2 className="max-w-4xl mb-5 font-sans text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl sm:leading-none md:mb-6 group">
            <span className="inline-block mb-1 sm:mb-4">Key Pillars of AeroAegis Product Engineering
            </span>
            <div className="h-1 ml-auto duration-300 origin-left transform bg-primary scale-x-30 group-hover:scale-x-100" />
          </h2>
          
        </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
      
        <div className="space-y-8">
          <div className="space-y-4">
            <h1 className="text-4xl md:text-5xl font-bold leading-tight text-gray-900">
              Customer-Centric Design
            </h1>
            <p className="text-lg text-gray-600">
            We prioritize a customer-first approach in every product we create, ensuring solutions are tailored to address real needs and deliver meaningful impact through thoughtful design.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-8">
            {/* Feature 1 */}
            <div className="space-y-3">
              <div className="flex items-center space-x-2">
                <FaSearch className="w-6 h-6 text-indigo-600" />
                <h3 className="font-semibold text-gray-900">Empathy-Driven Research</h3>
              </div>
              <p className="text-gray-600 text-sm">
              We leverage user research and customer feedback to deeply understand pain points and aspirations, ensuring our solutions are rooted in real-world insights.
              </p>
            </div>

            {/* Feature 2 */}
            <div className="space-y-3">
              <div className="flex items-center space-x-2">
                <FaUserAlt className="w-6 h-6 text-indigo-600" />
                <h3 className="font-semibold text-gray-900">Human-Centered Design
                </h3>
              </div>
              <p className="text-gray-600 text-sm">
              Our approach focuses on creating intuitive, user-friendly experiences that seamlessly integrate functionality with aesthetics.
              </p>
            </div>
            {/* Feature 3 */}
            <div className="space-y-3">
              <div className="flex items-center space-x-2">
                <FaChartLine className="w-6 h-6 text-indigo-600" />
                <h3 className="font-semibold text-gray-900">Market Insight Integration</h3>
              </div>
              <p className="text-gray-600 text-sm">
              By combining market analysis with customer needs, we develop products that are both innovative and highly relevant in their industry.
              </p>
            </div>
            {/* Feature 4 */}
            <div className="space-y-3">
              <div className="flex items-center space-x-2">
                <FaCheckCircle className="w-6 h-6 text-indigo-600" />
                <h3 className="font-semibold text-gray-900">Delivering Value
                </h3>
              </div>
              <p className="text-gray-600 text-sm">
              Each product is designed to deliver measurable business value, solving pressing problems and exceeding user expectations.
              </p>
            </div>



           
          </div>
        </div>

        <div className="relative h-[500px] rounded-3xl overflow-hidden">
          <img
            src={img1}
            alt="Workspace with laptop and plant"
            className="object-cover w-full h-full rounded-3xl"
          />
        </div>
      </div>
    </div>
  )
}